/*
  Product gallery, Nooroots style (see assets/nr-product-gallery.css).
  Tapping a thumbnail in a "Thumbnail carousel" strip slides the strip so that
  thumbnail sits in the middle, so tapping the last one in view moves the
  strip along. This stands in for Dawn's arrows, which the stylesheet hides.
  Dawn's media-gallery.js still swaps the main photo.
*/
(() => {
  if (window.nrProductGallery) return;
  window.nrProductGallery = true;

  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  const pending = new WeakMap();

  document.addEventListener('click', (event) => {
    if (!(event.target instanceof Element)) return;
    const item = event.target.closest(
      'media-gallery[data-desktop-layout="thumbnail_slider"] .thumbnail-list__item'
    );
    const list = item && item.closest('.thumbnail-list');
    if (!list || list.scrollWidth <= list.clientWidth + 1) return;

    // Runs after Dawn's own scroll for the same tap, so this one wins.
    cancelAnimationFrame(pending.get(list));
    pending.set(
      list,
      requestAnimationFrame(() => {
        pending.delete(list);
        const itemLeft = item.getBoundingClientRect().left - list.getBoundingClientRect().left + list.scrollLeft;
        const target = itemLeft - (list.clientWidth - item.clientWidth) / 2;
        const max = list.scrollWidth - list.clientWidth;
        list.scrollTo({
          left: Math.max(0, Math.min(target, max)),
          behavior: reducedMotion.matches ? 'auto' : 'smooth',
        });
      })
    );
  });
})();
